














































import {Vue, Component, Ref, PropSync} from 'vue-property-decorator';
import {Action, Getter} from "vuex-class";
import {ImportZonesItem} from "@/store/tarification/types";
import {SelectWings} from "wings-ui-components";
import { CollapseTransition } from "vue2-transitions";
import {notifyError} from "@/utils/notify-helper";
import Swal from "sweetalert2";
import {readFileAsBinary} from "@/utils/download-helper"
import {ActionLog} from "@/store/auth/types";
import {getTranslatedParams} from "@/utils/notify-utils";

@Component({components: {CollapseTransition,SelectWings}})
export default class ImportPoolNumbers extends Vue {
  @PropSync('show') is_show!: boolean;
  @PropSync('pool_id') poolNumberId!: number;
  @Ref('validator') validator: any;
  @Action("importPoolNumbers") actionImport: any;
  @Action("getPoolNumbers") actionGetPoolNumbers: any;
  @Action("actionLog") actionLog: any;
  @Getter delimiterList:any;

  private importRequest: ImportZonesItem = {
    name: undefined,
    file: undefined,
    delimiter: ',',
  };
  private logObject: ActionLog = {};

  onFileUpload (evt: any) {
    this.importRequest.file = evt[0]
  }

  async importZones():Promise<void> {
    if (!await this.validator.validate()) {
      notifyError(null, this.validator.errors)
      return;
    }
    try {
      const fileString = await readFileAsBinary(this.importRequest.file);
      const fileName = this.importRequest.file?.name ?? this.importRequest.name ?? 'file.csv';
      const delimeter = this.importRequest.delimiter === 'space' ? ' ' : this.importRequest.delimiter;
      const payload = {
        id: this.poolNumberId,
        name: fileName,
        file: btoa(fileString),
        delimeter,
      };
      this.logObject = {
        action_page: this.$route.meta.msgKey,
        action: "Import",
        action_status: "success",
        object_type: "Page",
        addititional_info: getTranslatedParams(payload)
      };
      const response: any = await this.actionImport(payload);
      await this.actionLog(this.logObject);
      await this.actionGetPoolNumbers({ id: this.poolNumberId });
      await Swal.fire({
        type: 'success',
        title: <string> this.$t('import_success'),
        confirmButtonClass: "md-button md-success",
        html: `Загружено записей: ${response?.data?.numbers_count ?? response?.data?.recipients_count ?? 0}`,
        showConfirmButton: true
      });
    } catch (error) {
      this.actionLog({...this.logObject, action_status: 'failed'});
      notifyError(error);
    }
  }
}
